var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "600pt",
    height: "600pt",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.198547%,8.198547%,7.798767%)",
      fillOpacity: 1
    },
    d: "M 300 584.347656 C 296.078125 584.347656 292.390625 582.820313 289.617188 580.046875 L 19.953125 310.382813 C 14.230469 304.65625 14.230469 295.34375 19.953125 289.617188 L 289.617188 19.953125 C 292.390625 17.179688 296.078125 15.652344 300 15.652344 C 303.921875 15.652344 307.609375 17.179688 310.382813 19.953125 L 580.046875 289.617188 C 585.769531 295.34375 585.769531 304.65625 580.046875 310.382813 L 310.382813 580.046875 C 307.609375 582.820313 303.921875 584.347656 300 584.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 300 10.652344 C 294.964844 10.652344 289.925781 12.574219 286.082031 16.417969 L 16.417969 286.085938 C 8.730469 293.769531 8.730469 306.230469 16.417969 313.917969 L 286.082031 583.582031 C 289.925781 587.425781 294.964844 589.347656 300 589.347656 C 305.035156 589.347656 310.074219 587.425781 313.917969 583.582031 L 583.582031 313.917969 C 591.269531 306.230469 591.269531 293.769531 583.582031 286.085938 L 313.917969 16.417969 C 310.074219 12.574219 305.035156 10.652344 300 10.652344 M 300 20.652344 C 302.585938 20.652344 305.015625 21.660156 306.847656 23.488281 L 576.511719 293.15625 C 578.339844 294.980469 579.347656 297.414063 579.347656 300 C 579.347656 302.585938 578.339844 305.015625 576.511719 306.847656 L 306.847656 576.511719 C 305.015625 578.339844 302.585938 579.347656 300 579.347656 C 297.414063 579.347656 294.984375 578.339844 293.152344 576.511719 L 23.488281 306.847656 C 21.660156 305.015625 20.652344 302.585938 20.652344 300 C 20.652344 297.414063 21.660156 294.980469 23.488281 293.15625 L 293.152344 23.488281 C 294.984375 21.660156 297.414063 20.652344 300 20.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.198547%,8.198547%,7.798767%)",
      fillOpacity: 1
    },
    d: "M 342.4375 166.320313 C 342.4375 189.757813 323.4375 208.757813 300 208.757813 C 276.5625 208.757813 257.5625 189.757813 257.5625 166.320313 C 257.5625 142.882813 276.5625 123.882813 300 123.882813 C 323.4375 123.882813 342.4375 142.882813 342.4375 166.320313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeDasharray: "148.1,296.2",
      strokeMiterlimit: 10
    },
    d: "M 3424.375 4336.796875 C 3424.375 4102.421875 3234.375 3912.421875 3000 3912.421875 C 2765.625 3912.421875 2575.625 4102.421875 2575.625 4336.796875 C 2575.625 4571.171875 2765.625 4761.171875 3000 4761.171875 C 3234.375 4761.171875 3424.375 4571.171875 3424.375 4336.796875 Z M 3424.375 4336.796875 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.198547%,8.198547%,7.798767%)",
      fillOpacity: 1
    },
    d: "M 240.402344 434.519531 L 290.5 242.554688 L 309.5 242.554688 L 359.59375 434.519531 C 359.59375 434.519531 343.515625 446.621094 306.140625 446.621094 C 268.769531 446.621094 240.402344 434.519531 240.402344 434.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 2474.414063 1629.023438 C 2429.21875 1644.101563 2404.023438 1654.804688 2404.023438 1654.804688 L 2422.96875 1727.382813 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeDasharray: "166.72,333.44",
      strokeMiterlimit: 4
    },
    d: "M 2507.1875 2050.039063 L 2843.984375 3340.546875 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 2886.054688 3501.875 L 2905 3574.453125 L 2980 3574.453125 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3020 3574.453125 L 3095 3574.453125 L 3113.945313 3501.875 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeDasharray: "166.72,333.44",
      strokeMiterlimit: 4
    },
    d: "M 3198.125 3179.257813 L 3534.921875 1888.710938 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3577.03125 1727.382813 L 3595.976563 1654.804688 C 3595.976563 1654.804688 3574.882813 1638.984375 3530.3125 1618.75 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 150,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeDasharray: "134.61,269.22",
      strokeMiterlimit: 4
    },
    d: "M 3271.523438 1547.890625 C 3210.78125 1539.296875 3140.898438 1533.828125 3061.40625 1533.828125 C 2880.390625 1533.828125 2720.46875 1562.226563 2603.710938 1591.484375 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/Invisible.85cbfa1f317650aea692e6b8fc5b1282.svg";
export { ForwardRef as ReactComponent };